// i18n 辅助 mixin，用于翻译角色和版本
export default {
  methods: {
    /**
     * 获取角色的本地化名称
     * @param {Object|String} role - 角色对象或角色ID
     * @returns {String} 本地化的角色名称
     */
    getRoleName(role) {
      const roleId = typeof role === "string" ? role : role.id;
      if (!roleId) return "";

      const key = `roleDetails.${roleId}.name`;
      const translated = this.$t(key);

      // 如果翻译不存在，返回原始名称
      if (translated === key) {
        return typeof role === "object" ? role.name : roleId;
      }
      return translated;
    },

    /**
     * 获取角色的本地化能力描述
     * @param {Object|String} role - 角色对象或角色ID
     * @returns {String} 本地化的能力描述
     */
    getRoleAbility(role) {
      const roleId = typeof role === "string" ? role : role.id;
      if (!roleId) return "";

      const key = `roleDetails.${roleId}.ability`;
      const translated = this.$t(key);

      // 如果翻译不存在，返回原始描述
      if (translated === key) {
        return typeof role === "object" ? role.ability : "";
      }
      return translated;
    },

    /**
     * 获取版本的本地化名称
     * @param {Object|String} edition - 版本对象或版本ID
     * @returns {String} 本地化的版本名称
     */
    getEditionName(edition) {
      const editionId = typeof edition === "string" ? edition : edition.id;
      if (!editionId) return "";

      const key = `editions.${editionId}.name`;
      const translated = this.$t(key);

      // 如果翻译不存在，返回原始名称
      if (translated === key) {
        return typeof edition === "object" ? edition.name : editionId;
      }
      return translated;
    },

    /**
     * 获取版本的本地化描述
     * @param {Object|String} edition - 版本对象或版本ID
     * @returns {String} 本地化的描述
     */
    getEditionDescription(edition) {
      const editionId = typeof edition === "string" ? edition : edition.id;
      if (!editionId) return "";

      const key = `editions.${editionId}.description`;
      const translated = this.$t(key);

      // 如果翻译不存在，返回原始描述
      if (translated === key) {
        return typeof edition === "object" ? edition.description : "";
      }
      return translated;
    },

    /**
     * 获取阵营的本地化名称
     * @param {String} team - 阵营名称 (townsfolk, outsider, minion, demon, traveler, fabled)
     * @returns {String} 本地化的阵营名称
     */
    getTeamName(team) {
      return this.$t(`roles.${team}`);
    },
  },
};
